import { render, staticRenderFns } from "./PrintTemplateDesign.vue?vue&type=template&id=3a19dfc2&scoped=true"
import script from "./PrintTemplateDesign.vue?vue&type=script&lang=js"
export * from "./PrintTemplateDesign.vue?vue&type=script&lang=js"
import style0 from "./PrintTemplateDesign.vue?vue&type=style&index=0&id=3a19dfc2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a19dfc2",
  null
  
)

export default component.exports